import React, { useState } from 'react'
import {
  Footer,
  Search,
  StyledTable,
  TableCell,
  TableContainer,
  TableHeader,
} from './styled'
import { Button } from '../../../../components/common/Button'
import { Input } from '../../../../components/common/Input'
import { MagnifyingGlass } from '@phosphor-icons/react'
import useFilteredData from '../../../../hooks/searchHook'

export const AlwaysAlertTable = ({ onclick, data, base }) => {
  const { filteredData, filterData } = useFilteredData(data)
  const [search, setSearch] = useState('')

  const handleSearchChange = (e) => {
    setSearch(e.target.value)
    filterData(e.target.value)
  }

  return (
    <>
      <TableContainer>
        <div>
          <Search onSubmit={(e) => e.preventDefault}>
            <span>Pesquisar</span>
            <Input.Root>
              <Input.Wrapper
                borderColor="#CECECE"
                backgroundColor="#F7F7F7"
                outlineColor=""
              >
                <Input.Content
                  id=""
                  onChange={handleSearchChange}
                  type="text"
                  value={search}
                  placeholder="Usuário"
                />
                <Input.Icon>
                  <MagnifyingGlass size={16} color="#494949" />
                </Input.Icon>
              </Input.Wrapper>
            </Input.Root>
          </Search>
        </div>

        <StyledTable>
          <thead>
            <tr>
              <TableHeader className="first">Nome de usuário</TableHeader>
              <TableHeader className="second">Status</TableHeader>
              <TableHeader>Telefone</TableHeader>
              <TableHeader>Posto</TableHeader>
              <TableHeader>categoria</TableHeader>
              <TableHeader>1° disparo</TableHeader>
              <TableHeader>Resposta</TableHeader>
              <TableHeader>2° disparo</TableHeader>
              <TableHeader>Resposta</TableHeader>
              <TableHeader>3° disparo</TableHeader>
              <TableHeader>Resposta</TableHeader>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((alwaysAlert) => {
              const answered = alwaysAlert.AlwaysAlertMessages.filter(
                (el) => el.answered_at,
              )
              return (
                <tr key={alwaysAlert.id}>
                  <TableCell>{alwaysAlert.name}</TableCell>
                  <TableCell>
                    <Button.Root
                      onClick={() =>
                        onclick(alwaysAlert.id, alwaysAlert.id_user)
                      }
                      backgroundColor={
                        answered.length <= 0 ? '#F33C3C' : '#68D873'
                      }
                      type="button"
                    >
                      <Button.Content
                        title={
                          answered.length <= 0 ? 'Não respondido' : 'Respondido'
                        }
                        color="#fff"
                      />
                    </Button.Root>
                  </TableCell>
                  <TableCell>{alwaysAlert.phone}</TableCell>
                  <TableCell>{alwaysAlert.outpost}</TableCell>
                  <TableCell>
                    {alwaysAlert.type === 'EMPLOYEE' ? 'Segurança' : 'Posto'}
                  </TableCell>
                  {alwaysAlert.AlwaysAlertMessages.map(
                    (alwaysAlertMessages) => {
                      return (
                        <>
                          <TableCell>
                            {alwaysAlertMessages.sent_at &&
                              new Date(
                                alwaysAlertMessages.sent_at,
                              ).toLocaleString()}
                          </TableCell>
                          <TableCell>
                            {alwaysAlertMessages.answered_at &&
                              new Date(
                                alwaysAlertMessages.answered_at,
                              ).toLocaleString()}
                          </TableCell>
                        </>
                      )
                    },
                  )}
                </tr>
              )
            })}
          </tbody>
        </StyledTable>
        <Footer>
          <span>{`Listando ${data.length} alertas`}</span>
        </Footer>
      </TableContainer>
    </>
  )
}
